module.exports = "/_next/static/images/buyers_fone-115a55df16e6c9af7c23c01f83f4a05b.png";